import { Skeleton } from '@chakra-ui/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { ExploReportBuilderContainer } from 'packages/explo/ui/ExploReportBuilderContainer';

export const PortfolioReportBuilderContainer: React.FC<{
  organizationId: string;
  creditFacilityId: string;
}> = withLDConsumer()(({ organizationId, creditFacilityId, flags }) => {
  const history = useHistory();

  if (!flags) {
    return (
      <Skeleton
        height="600px"
        data-testid="portfolio-report-builder-container-missing-flag"
      />
    );
  }

  // Technically this should never hit as the route has already hidden this,
  // but just keeping as extra safety
  if (!flags.showExploReportBuilder) {
    history.push('/portfolio/overview/facilities');
    return <Skeleton height="600px" />;
  }

  return (
    <ExploReportBuilderContainer
      organizationId={organizationId}
      creditFacilityId={creditFacilityId}
    />
  );
});
